import { Blog } from 'components';

const BlogPage = () => {
	return <Blog />;
};

export default BlogPage;
